export const CENSORED = "******";